import styles from "./Section5.module.scss";

export const Section5 = function () {
  return (
    <section id="progOutline" className={`${styles.section5Wrapper} cc--component-container`}>
      <div className={styles.section5Container}>
        <div className={styles.section5Content}>
          <h3>COURSE CURRICULUM</h3>
          <span>Over the duration of this online program, you&rsquo;ll work through the following modules:</span>
          <div className={styles.rowContainer}>
            <div className={styles.firstCol}>
              <p>
                <strong>Module 1: An Introduction to Artificial Intelligence</strong>
                <br />
                Deduce how to gain strategic advantage through the use of different kinds of intelligence.
              </p>
              <p>
                <strong>Module 2: Machine Learning in Business</strong>
                <br />
                Evaluate the appropriateness of a business application for machine learning.
              </p>
              <p>
                <strong>Module 3: Generative AI in Business</strong>
                <br />
                Explore generative AI and how it can be applied in a business context to gain strategic advantage.
              </p>
            </div>
            <div className={styles.secondCol}>
              <p>
                <strong>Module 4: Robotics in Business</strong>
                <br />
                Evaluate the appropriateness of a business application for robotics.
              </p>
              <p>
                <strong>Module 5: Artificial Intelligence in Business and Society</strong>
                <br />
                Assess the impact of AI on the future of work and society.
              </p>
              <p>
                <strong>Module 6: The Future of Artificial Intelligence</strong>
                <br />
                Develop a road map for an organization to gain strategic advantage through the use of artificial
                intelligence.
              </p>
            </div>
          </div>
          <p>
            The course culminates in a <strong>capstone project</strong> where you’ll develop an AI roadmap for your
            organization, enabling the deployment of AI initiatives and positioning your business for competitive
            advantage.
          </p>
          <p className={styles.note}>
            <small>
              <em>
                Please note that module titles and their contents are subject to change during program development.
              </em>
            </small>
          </p>
        </div>
      </div>
    </section>
  );
};
